import { render, staticRenderFns } from "./done.vue?vue&type=template&id=708636ae"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports